import { SiteConfigContextValue } from '@common/core/settings/site-config-context';
import { CommonUploadType } from '@common/uploads/common-upload-type';
import { message } from '@ui/i18n/message';
import { FileEntrySharedNotificationRenderer } from './drive/notifications/file-entry-shared-notification-renderer';

const fileEntrySharedNotif = 'App\\Notifications\\FileEntrySharedNotif';

export const SiteConfig: Partial<SiteConfigContextValue> = {
  notifications: {
    renderMap: {
      [fileEntrySharedNotif]: FileEntrySharedNotificationRenderer,
    },
  },
  tags: {
    types: [{name: 'label', system: true}],
  },
  roles: {
    types: [
      {type: 'users', label: message('Users'), permission_type: 'users'},
      {
        type: 'workspace',
        label: message('Workspace'),
        permission_type: 'workspace',
      },
    ],
  },
};

export const UploadType = {
  ...CommonUploadType,
  tmkdrive: 'tmkdrive',
} as const;
